import { Component } from 'vue-property-decorator';


import { Type } from "src/utils";

/**
 * 商品大分类
 * @enum
 * @version 1.0.0
 */
enum GoodsClass
{
    /**
     * 实体预约卡
     * @member
     */
     PhysicalAppointCard = 1,

    /**
     * 保健品商品
     * @member
     */
     HealthProducts = 2,

    /**
     * 检测类商品
     * @member
     */
     TestingProducts = 3,

    /**
     * 药品
     * @member
     */
     Medicine = 4,

    /**
     * 二类医疗器械商品
     * @member
     */
     DeviceCommodity = 5,

    /**
     * 食品类
     * @member
     */
     Food = 6
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(GoodsClass,
{
    PhysicalAppointCard:
    {
        alias: "实体预约卡",
        description: ""
    },
    HealthProducts:
    {
        alias: "保健品商品",
        description: ""
    },
    TestingProducts:
    {
        alias: "检测类商品",
        description: ""
    },
    Medicine:
    {
        alias: "药品",
        description: ""
    },
    DeviceCommodity:
    {
        alias: "二类医疗器械商品",
        description: ""
    },
    Food:
    {
        alias: "食品类",
        description: ""
    }
});

export default GoodsClass;
